<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2024-07-23 15:12:57
 * @LastEditors  : yangxr
 * @Description  : 二维码
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\soiltest\flowcomponent\genQrCode.vue
-->
<template>
  <div ref="qr-area"></div>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  props: ["text"],
  data() {
    return {};
  },
  mounted() {
    this.genQRCode();
  },
  methods: {
    genQRCode() {
      // 获取第一个元素
      let curDom = this.$refs["qr-area"];
      const encoder = new TextEncoder("utf-8");
      const originalString = this.text;
      const utf8Array = encoder.encode(originalString);
      const utf8String = new TextDecoder("utf-8").decode(utf8Array);
      let code = new QRCode(curDom, {
        text: utf8String,
        width: 100,
        height: 100,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.H, //容错率，L/M/H
      });
      this.$forceUpdate();
      console.log(code);
    },
  },
};
</script>
